
import { defineComponent, PropType, reactive, toRaw } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { GatewayMicroserviceT } from '@/core/types/gateway.types'

// realisation
import { gateway } from '@/core/realisations/gateway.realisation'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<GatewayMicroserviceT>,
            default: null,
        },
        isImporting: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update'],
    setup(props, { emit }) {
        const state = reactive({
            is_importing: false,
        })

        const importRoutes = async () => {
            const answer = confirm(
                `Вы действительно хотите импортировать routes?\n${props.item.host}`
            )
            if (!answer) return

            try {
                state.is_importing = true
                await gateway.importMicroserviceRoutes(props.item.id)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_importing = false
            }
        }

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        return { state, emitUpdate, importRoutes }
    },
})
